module.exports = __webpack_public_path__ + "img/1545878823.e0fb2515.jpg";